import {
  CgsInventory,
  CgsSliceReducer,
  initialState,
  submit,
  updateCgsItem,
  validate
} from './cgsSlice';

import { splitChunks } from 'lib/utils/splitChunks';
import { FormattedSection } from '../paginationSlice';

import { PagedQuestionnaireWrapper } from 'features/patient/assessment/_components/questionnaire-paginator';
import {
  PagedQuestionnaireProps,
  QUESTIONNAIRE_TITLE_24_HR
} from '../../_components/questionnaire-paginator-types';
import { QuestionConfigWithResponse } from 'features/patient/assessment/_components/questionnaire-page';
import { CgsQuestionnaire } from 'features/patient/_utils/questionnaires';
import { QuestionnaireConfig } from 'data/questionnaire-config-type';
import { Inventory } from 'lib/documents';

export function PaginationCombined(
  props: Pick<PagedQuestionnaireProps<any, any>, 'storageKey'>
) {
  return (
    <PagedQuestionnaireWrapper
      initialState={initialState}
      reducer={CgsSliceReducer as any}
      getData={state => state.cgs}
      storageKey={props.storageKey}
      actions={{
        updateItem: updateCgsItem as any,
        formatData: formatCgs,
        submit: submit,
        validate
      }}
      pageTitle={QUESTIONNAIRE_TITLE_24_HR}
    />
  );
}

// purpose is to standardize paginationCombined data intake;
export function formatCgs(
  _data: CgsInventory,
  pageLimit: number
): FormattedSection[] {
  return formatQuestionnaireData(CgsQuestionnaire, _data, pageLimit);
}

export function formatQuestionnaireData<T extends Inventory>(
  questionnaire: QuestionnaireConfig,
  currentState: T,
  pageLimit: number
): FormattedSection[] {
  const subsections = Object.keys(questionnaire.subsections).map(
    key => questionnaire.subsections[key]
  );
  return subsections.map(subsection => {
    const questions: QuestionConfigWithResponse[] = subsection.questions.map(
      question => ({
        ...question,

        // We null-coalesce the value to -1 so that undefined values during debugging do not break the questionnaire logic
        value: currentState.data[question.title] ?? -1
      })
    );
    const pages = splitChunks(questions, pageLimit);
    return {
      ...subsection,
      page: pages,
      pageLength: pages.length,
      questions: questions
    };
  });
}
